import { useContext, useMemo } from 'react';

import { useCurrentUserWithRole } from '../../../../../../../../../courses/hooks';
import { selectAccessibilityPrefs } from '../../../../../../../../../db/app/selectors';
import {
  selectComment,
  selectCommentMyReactions,
  selectContextData,
} from '../../../../../../../../../db/comments/selectors';
import { CommentContext } from '../../../../../../../../../db/shared/types';
import { useAppSelector } from '../../../../../../../../../store/hooks';
import { CommentsContext } from '../../../../../../../../Context';
import { getCanAwardComment } from '../../../../../../../../helpers';

export interface Props {
  commentId: MongoId;
}

const useAwardVM = ({ commentId }: Props) => {
  const { turnOff } = useAppSelector((state) => selectAccessibilityPrefs(state));
  const isScreenReaderOn = !turnOff;

  const comment = useAppSelector((state) => selectComment(state, commentId));
  const myReactions = useAppSelector((state) => selectCommentMyReactions(state, commentId));
  const contextData = useAppSelector((state) => selectContextData(state));

  const currentUser = useCurrentUserWithRole();

  const canAward = useMemo(() => {
    if (contextData?.type === CommentContext.DISCUSSION) {
      return getCanAwardComment({
        comment,
        context: contextData?.type,
        discussion: contextData.activity,
        currentUser,
      });
    }
    return getCanAwardComment({ comment, context: contextData?.type, discussion: undefined, currentUser });
  }, [comment, contextData?.type, contextData?.activity, currentUser]);

  const awardPoints = myReactions?.awardPoints ?? 0;
  const hasAwarded = Boolean(awardPoints);

  const { setAwardingCommentId } = useContext(CommentsContext);

  const handleAwardClick = () => {
    setAwardingCommentId(commentId);
  };

  return { isScreenReaderOn, canAward, hasAwarded, awardPoints, handleAwardClick };
};

export default useAwardVM;
